import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { useNavigate } from 'react-router-dom'
import SupportTicketStatus from '../../components/admin/SupportTicketStatus'
import UserTypeDisplay from '../../components/common/UserTypeDisplay'
import { useFilters } from '../../hooks/useFilters'
import { FILTER_TYPES } from '../../constants/filters'
import StatDisplay from '../../components/common/StatDisplay'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { formatTime } from '../../utils/date.util'
import DisplayShopName from '../../components/common/DisplayShopName'
import USER_TYPE from '../../constants/userType'

const SupportPage = () => {
  const navigate = useNavigate()
  const { filters, renderFilters, renderPagination } = useFilters()
  const { data } = useQuery({
    queryKey: QueryKeys.adminSupportTickets(filters),
    queryFn: () => handleGetRequest('/admin/support/tickets', filters),
  })
  const { data: stats } = useQuery({
    queryKey: QueryKeys.adminSupportTicketsStats(),
    queryFn: () => handleGetRequest('/admin/support/stats'),
  })
  const tickets = data?.data || []

  return (
    <>
      <div className="flex gap-6 mb-8">
        <StatDisplay label="Pending" value={stats?.data?.pendingTickets} />
        <StatDisplay label="In Progress" value={stats?.data?.inProgressTickets} />
        <StatDisplay label="Resolved" value={stats?.data?.resolvedTickets} />
      </div>

      <div className="flex gap-4 w-full mb-6">
        {renderFilters([
          FILTER_TYPES.search,
          FILTER_TYPES.userType,
          FILTER_TYPES.supportTicketStatus,
          FILTER_TYPES.date,
          FILTER_TYPES.sort,
        ])}
      </div>

      <div className="border border-gray-300 rounded-md overflow-hidden bg-background">
        <table className="w-full text-left">
          <thead>
            <tr className="bg-secondary-100 [&>th]:px-6 [&>th]:py-4 [&>th]:font-medium [&>th]:text-black [&>th]:text-base">
              <th>ID</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tickets.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center py-8 text-gray-500">
                  No tickets found for the selected filters.
                </td>
              </tr>
            ) : (
              tickets.map((ticket) => (
                <tr
                  key={ticket.id}
                  className="border-t border-gray-200 last:border-b-0 [&>td]:px-6 [&>td]:py-4"
                >
                  <td>{ticket.id}</td>
                  <td>
                    {ticket.userType === USER_TYPE.customer ? (
                      <>
                        <span className="mr-2">{ticket.userName}</span>
                        <UserTypeDisplay userType={ticket.userType} />
                      </>
                    ) : (
                      <>
                        <DisplayShopName
                          shop={{
                            name: ticket.shopName,
                            isPremium: ticket.isShopPremium,
                            isVerified: ticket.isShopApproved,
                          }}
                        />
                        <div className="text-gray-600 text-sm font-semibold">
                          <span className="mr-2">{ticket.userName}</span>
                          <UserTypeDisplay userType={ticket.userType} />
                        </div>
                      </>
                    )}
                  </td>
                  <td>{ticket.phone}</td>

                  <td>{formatTime(ticket.date)}</td>
                  <td>
                    <SupportTicketStatus status={ticket.status} />
                  </td>
                  <td>
                    <div className="flex gap-2">
                      <button
                        className="bg-secondary-600 text-white rounded-[4px] w-[101px] h-[30px] flex items-center justify-center gap-1 text-[16px] font-medium"
                        onClick={() => navigate(`/admin/support/${ticket.id}`)}
                      >
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {renderPagination(data?.meta)}
    </>
  )
}

export default SupportPage
